'use strict';

exports.encode = require('./encode');

